<template>
  <b-col cols="12"
      lg="6"
      id="user_data"
      class="user-data tr">
      <div class="data-outer">
          <b-row>
              <b-col cols="6" lg="5">
                  <div class="form-label">
                      User name
                  </div>
              </b-col>
              <b-col cols="6" lg="7">
                  <div class="form-label">{{ username }}</div>
              </b-col>
          </b-row>
          <b-row>
              <b-col cols="6" lg="5">
                  <div class="form-label">
                      Email
                  </div>
              </b-col>
              <b-col cols="6" lg="7">
                  <div class="form-label">{{ email }}</div>
              </b-col>
          </b-row>
          <b-row>
              <b-col cols="6" lg="5">
                  <div class="form-label">
                      Address
                  </div>
              </b-col>
              <b-col cols="6" lg="7">
                  <div class="form-label">{{ street }}<br>{{ zip }} {{ city }}</div>
              </b-col>
          </b-row>
          <b-row>
              <b-col cols="6" lg="5">
                  <div class="form-label">
                      Phone number
                  </div>
              </b-col>
              <b-col cols="6" lg="7">
                  <div class="form-label">{{ phoneNumber }}</div>
              </b-col>
          </b-row>
          <b-row>
              <b-col cols="6" lg="5">
                  <div class="form-label">
                      Reflink
                  </div>
              </b-col>
              <b-col cols="6" lg="7">
                  <div class="form-label reflink"
                       :title="'Click to copy your reflink'"
                       v-clipboard="'//' + reflink"
                       v-tippy="{ placement : 'top',  arrow: true }">{{ reflink }}</div>
              </b-col>
          </b-row>
      </div>
      <b-row>
          <b-col cols="12" lg="7">
              <router-link :to="{ name: 'ProfileEditData' }" class="button--primary" v-html="isVerified ? 'Show data' : 'Edit data'"></router-link>
          </b-col>
      </b-row>
  </b-col>
</template>

<script>
    export default {
        computed: {
            username () {
                return this.$store.getters.user.login
            },
            email () {
                return this.$store.getters.user.email
            },
            street () {
                return this.$store.getters.user.street ? this.$store.getters.user.street : '-'
            },
            zip () {
                return this.$store.getters.user.zip ? this.$store.getters.user.zip : ''
            },
            city () {
                return this.$store.getters.user.city ? this.$store.getters.user.city : ''
            },
            phoneNumber () {
                return this.$store.getters.user.phoneNumber ? this.$store.getters.user.phoneNumber : ''
            },
            reflink () {
                return `futuro.network/register/${this.$store.getters.user.login ? this.$store.getters.user.login : ''}`
            },
            isVerified () {
                return this.$store.getters.user.isVerified
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../../assets/scss/_colors.scss';

    .reflink{
        cursor: pointer;
    }

    .user-data{
        h3{
            color: $base1;
            font-weight: bold;
            margin: 0;
        }

        .form-label{
            margin-bottom: 18px;
        }

        .button--primary{
            width: 100%;
            margin-top: 22px;
        }

        select{
            width: 100%;
            box-sizing: border-box;
        }

        .form-label{
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    @media (min-width: 768px) {
        .data-outer{
            min-height: 224px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile/settings/UserData.vue